import { render, staticRenderFns } from "./CustomerAvailableTimeSlots.vue?vue&type=template&id=d410519a&scoped=true&"
import script from "./CustomerAvailableTimeSlots.vue?vue&type=script&lang=js&"
export * from "./CustomerAvailableTimeSlots.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAvailableTimeSlots.vue?vue&type=style&index=0&id=d410519a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d410519a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VDivider,VIcon})
